import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-grafana-embed',
  template: `
    <iframe
      [src]="safeSrc"
      width="100%"
      [style.height.px]="height"
      frameborder="0"
      style="border:0"
      loading="lazy"
    ></iframe>
  `,
  standalone: true
})
export class GrafanaEmbedComponent {
  safeSrc!: SafeResourceUrl;

  @Input() height = 900;

  @Input() set src(url: string) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  constructor(private sanitizer: DomSanitizer) {}
}
